import { useFormik, Form, FormikProvider } from "formik";
import { Button, Input, Select } from "styled";
import InputField from "components/formik/InputField";
import Model from "components/Modal";
import { createDocument, getAllData, updateDocumentByID } from "apis/customApiHandler";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import axios from "apis/axios";
import { useCallback, useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useLocation } from "react-router-dom";
import { saveErrorCreationEvent, emailDomain } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";
const AddUser = ({ handleClick, emailEntity }) => {
  const [selectedFleets, setSelectedFleets] = useState(emailEntity?.fleets?.map(fleet=> fleet?._id));
  const location = useLocation();
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
  getAllData("/customer-fleet", {
    limit: 300,
  })
);

function emailAlertEventFunc(eventName, modelName, params) {
    return saveErrorCreationEvent(eventName, modelName, "Email Alerts", location.pathname, params);
  }
const getFleetOptions = useCallback(() => {
  if (allFleets && allFleets.data && allFleets.data.length) {
    return [
      {
        label: "Select All",
        value: "all",
      },
      ...allFleets?.data?.map((fleet) => {
        return {
          value: fleet._id,
          label: fleet.fleetName,
        };
      }),
    ];
  }
}, [allFleets]);

  const reports = [
    {
      label: "Daily Fitment / Inspection Tracker",
      value: "daily-fitment-inspection-tracker",
    },
    { label: "Fleet Stock Summary", value: "fleet-stock-summary" },
    { label: "FM GRN Details", value: "fm-grn-details" },
    { label: "Order Report", value: "orders" },
    { label: "Vehicle Enrolment Agreement", value: "vehicle-enrollment-agreement" },
    { label: "Inspection Report", value: "inspection-report" },
    { label: "DTP Plan", value: "dtp-plan" },
    { label: "Approve External Stock Transfer", value: "external-stock-transfer" },
    { label: "Accept External Stock Transfer", value: "accept-external-stock-transfer" },
    { label: "Discount stock transfer", value: "stock-transfer-discount"},
    // { label: "Internal Stock Transfer", value: "internal-stock-transfer"},
    { label: "Daily Fleet Overview", value: "fleet-overview" },
    {label: "GRN Pending Report", value: "grn-pending-report"},
    { label: "Approve Retread Request", value: "approve-retread-request" },
    { label: "Complete Retread Request", value: "complete-retread-request" },

  ];

  const frequencies = [
    {
      label: "Daily",
      value: "daily",
    },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "Monthly" },
  ];
  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: {
      report: emailEntity?.report,
      email: emailEntity?.email,
      frequency: emailEntity?.frequency || "daily",
      fleets: selectedFleets,
    },
    onSubmit: async (values) => {
      const isEdit = emailEntity !== undefined;
      const eventParams = {
        report: values.report,
        email_domain: emailDomain(values.email),
        frequency: values.frequency,
        fleets: selectedFleets?.length === allFleets?.data?.length
          ? "All"
          : allFleets?.data?.filter((f) => selectedFleets?.includes(f._id))?.map((f) => f.fleetName),
        ...(isEdit && { edited_email_alert_id: emailEntity._id }),
      };
      try {
        emailAlertEventFunc(
          isEdit ? ANALYTICS_EVENTS.CLICK_EDIT_CHANGES : ANALYTICS_EVENTS.CLICK_SAVE_CHANGES,
          isEdit ? "Edit Email Alert" : "Add Email Alert",
          eventParams
        );
        const data = isEdit
          ? await updateDocumentByID("email-scheduler", emailEntity._id, {
              report: values.report.trim().toLowerCase(),
              email: values.email.trim().toLowerCase(),
              frequency: values.frequency.trim().toLowerCase(),
              fleets: selectedFleets,
            })
          : await createDocument("email-scheduler", {
              report: values.report.trim().toLowerCase(),
              email: values.email.trim().toLowerCase(),
              frequency: values.frequency?.trim()?.toLowerCase(),
              fleets: selectedFleets,
            });
        if (data) {
          emailAlertEventFunc(
            isEdit ? ANALYTICS_EVENTS.SYS_EDIT_EMAIL_ALERT_SUCCESS : ANALYTICS_EVENTS.SYS_ADD_EMAIL_ALERT_SUCCESS,
            isEdit ? "Edit Email Alert" : "Add Email Alert",
            eventParams
          );
          toast.success("Successfully saved");
          queryClient.invalidateQueries("email-scheduler");
          handleClick();
        }
      } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message;
        emailAlertEventFunc(
          isEdit ? ANALYTICS_EVENTS.SYS_EDIT_EMAIL_ALERT_ERROR : ANALYTICS_EVENTS.SYS_ADD_EMAIL_ALERT_ERROR,
          isEdit ? "Edit Email Alert" : "Add Email Alert",
          { errMsg }
        );
      }
    },

    validate: (values) => {
      let errors = {};
      if (!values.frequency) errors.frequency = "Required";
      if (!values.email) errors.email = "Required";
      if (!values.report) errors.report = "Required";
      return errors;
    },
  });

  return (
    <Model handleClick={handleClick} title={"Add Email Alert"} className="w-[500px]">
      <FormikProvider value={formik}>
        <Form className="px-5 text-gray-700 font-medium text-base w-full">
          <div className=" flex flex-col justify-center items-start gap-0 text-gray-600 font-normal mb-2">
            <label>
              Select Report
              <span className="text-red-500 required-dot">*</span>
            </label>
            <Select
              name="report"
              value={formik.values.report}
              onChange={formik.handleChange}
            >
              <option>Select report</option>
              {reports.map((report) => (
                <option key={report.value} value={report.value}>
                  {report.label}
                </option>
              ))}
            </Select>
            {formik.touched.report && formik.errors.report && (
              <p className="text-red-500 font-normal">{formik.errors.report}</p>
            )}
          </div>
          {!(formik.values.report ==="orders" || formik.values.report ==="inspection-report" || formik.values.report === "internal-stock-transfer" || formik.values.report ==="fleet-overview" || formik.values.report === "vehicle-enrollment-agreement") 
           && <div className=" flex flex-col justify-center items-start gap-0 text-gray-600 font-normal mb-2">
            <label>
              Select Frequency
              <span className="text-red-500 required-dot">*</span>
            </label>
            <Select
              name="frequency"
              value={formik.values.frequency}
              onChange={formik.handleChange}
            >
              <option>Select Frequency</option>
              {frequencies.map((frequency) => (
                <option key={frequency.value} value={frequency.value}>
                  {frequency.label}
                </option>
              ))}
            </Select>
            {formik.touched.frequency && formik.errors.frequency && (
              <p className="text-red-500 font-normal">
                {formik.errors.frequency}
              </p>
            )}
          </div>}
          <div>
          {formik.values.report ==="orders" || formik.values.report === "approve-retread-request" || formik.values.report ==="inspection-report" || formik.values.report === "internal-stock-transfer" || formik.values.report ==="fleet-overview" ||formik.values.report === "vehicle-enrollment-agreement" || formik.values.report === "accept-external-stock-transfer" || formik.values.report === "complete-retread-request" ? 
          <label className="w-full py-3 font-normal">
          Select Fleets
          <ReactSelect  
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2 font-normal"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: allFleets?.data?.find(
                    (item) => item?._id === fleet
                  )?.fleetName,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);

              if (allValues.includes("all")) {
                // console.log("first");

                setSelectedFleets(
                  allFleets?.data?.map((item) => {
                    return item._id;
                  })
                );
              } else {
              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );
              
              setSelectedFleets(value.map((fleet) => fleet.value));
              }
            }}
            name="fleets"
            isMulti={true}
        />
        </label>
: ""}

          </div>
          <div className=" flex flex-col justify-center items-start text-gray-600 font-normal mb-2">
            <label>
              Email
              <span className="text-red-500 required-dot">*</span>
            </label>
            <Input
              type="email"
              name="email"
              required={true}
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-red-500 font-normal">{formik.errors.email}</p>
            )}
          </div>
        </Form>
        <div className="px-5 flex justify-end items-center gap-4 py-8 flex-wrap sm:w-full">
          <Button bgSecondary onClick={handleClick}>
            Cancel
          </Button>
          <Button type="button" bgPrimary onClick={formik.handleSubmit}>
            Save Changes
          </Button>
        </div>
      </FormikProvider>
    </Model>
  );
};

export default AddUser;
